/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityHeaders
 */
export interface MonitEntityHeaders {
    /**
     * 
     * @type {string}
     * @memberof MonitEntityHeaders
     */
    EXTERNAL_ID?: string;
}

/**
 * Check if a given object implements the MonitEntityHeaders interface.
 */
export function instanceOfMonitEntityHeaders(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityHeadersFromJSON(json: any): MonitEntityHeaders {
    return MonitEntityHeadersFromJSONTyped(json, false);
}

export function MonitEntityHeadersFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityHeaders {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'EXTERNAL_ID': !exists(json, 'EXTERNAL-ID') ? undefined : json['EXTERNAL-ID'],
    };
}

export function MonitEntityHeadersToJSON(value?: MonitEntityHeaders | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'EXTERNAL-ID': value.EXTERNAL_ID,
    };
}

